export const RUNS_ON_ATLASSIAN_PROGRAM = 'Runs on Atlassian';